
const driverReport= {
  driverReportTitle: 'Informe del conductor',
  id: 'ID',
  driver: 'Conductor',
  filter: {
    driver: 'Conductor',
    car: 'Vehículo',
    submit: 'Filtrar',
    export: 'Exportar',
    clear: 'Borrar filtro',
    validation: {
      startDateRequired: 'La fecha de inicio es obligatoria',
      endDateRequired: 'La fecha de finalización es obligatoria',
    },
  },

  table: {
    drivers: 'Conductores',
    vehicles: 'Vehículos',
    trips: 'Viajes',
  },

  vechile: 'Vehículo',
  pax: 'Pax',
  cash: 'Efectivo',
  start: 'Início',
  end: 'Fin',
  reservations: {
    reservations: 'Reservas',
    table: {
      from: 'De',
      to: 'Hacia',
      date: 'Fecha',
      passenger: 'Pasajero',
      reservation: 'ID de reserva',
      paymentType: 'Tipo de pago',
      pax: 'Pax',
      pickup: 'Recoger',
      drop_off: 'Dejar',
      duration: 'Duración',
      car: 'Cochera',
    },
  },

  form: {
    dateEnd: 'Fecha de finalización',
    dateStart: 'Fecha de inicio',
  },
};


export default driverReport;